var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 7.625C13.665 7.239 12.864 7 12 7C9.238 7 7 9.238 7 12C7 12.864 7.239 13.665 7.625 14.375L9.141 12.859C9.058 12.586 9 12.301 9 12C9 10.343 10.343 9 12 9C12.301 9 12.586 9.058 12.859 9.141L14.375 7.625ZM20 2L21 3L17.504 6.496L15.535 8.465L14.121 9.879L9.879 14.121L8.465 15.535L6.496 17.504L3 21L2 20L5.327 16.673C3.836 15.463 2.687 13.854 2 12C3.512 7.925 7.213 5 12 5C13.513 5 14.912 5.299 16.173 5.827L20 2ZM15 12C15 11.836 14.977 11.679 14.952 11.521L11.521 14.952C11.679 14.977 11.836 15 12 15C13.657 15 15 13.657 15 12ZM22 12C20.488 16.075 16.787 19 12 19C10.622 19 9.337 18.751 8.165 18.309L9.933 16.541C10.564 16.829 11.261 17 12 17C14.762 17 17 14.762 17 12C17 11.261 16.829 10.564 16.541 9.933L18.936 7.538C20.301 8.722 21.353 10.254 22 12Z",
    fill: "#868B91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.9f3126240df1fa38767427d95cc1c205.svg";
export { ForwardRef as ReactComponent };